import React from "react";
import { useNavigate } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";

import styles from "./PageHeader.module.scss";
import { IconButton } from "../iconButton/IconButton";

type Props = {
  title: string;
  subtitle?: string;
  backButton?: boolean;
  backRoute?: string;
  rightSlot?: React.ReactNode;
  logo?: string;
};

export const PageHeader: React.FC<Props> = ({
  title,
  subtitle,
  backButton = true,
  backRoute,
  rightSlot,
  logo,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backRoute) {
      navigate(backRoute);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className={styles.Container}>
      <div className={styles.Left}>
        {backButton && (
          <IconButton
            icon={MdArrowBack}
            alt="Назад"
            onClick={handleBack}
            small
          />
        )}

        {logo && (
          <img src={logo} alt={title} className={styles.Logo} loading="lazy" />
        )}

        <div className={styles.Text}>
          <h1 className={styles.Title}>{title}</h1>
          {subtitle && <p className={styles.Subtitle}>{subtitle}</p>}
        </div>
      </div>

      {rightSlot && <div className={styles.Right}>{rightSlot}</div>}
    </div>
  );
};